import React, { useEffect, useState } from 'react';
import { Divider, Grid, IconButton, Stack, Table, TableBody, TableContainer, Typography } from '@mui/material';
import { MdOutlineModeEdit } from 'react-icons/md';
import { getPolling } from '../../../../../../../actions/meeting_actions';
import PollsTableBody from '../../../Poll/Components/PollTableBody';

const PollSection = (props) =>
{
	const { meetingId, handleNavi } = props;
	const [ pollsList, setPollsList ] = useState<any>([]);

	const getPollData = async () =>
	{
		const query = {
			sessionId : meetingId
		};

		try
		{
			const res = await getPolling(query);

			if (res?.status)
			{
				setPollsList(res?.data);
			}
			else
			{
				setPollsList([]);
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.log(err, '=================>');
		}
	};

	useEffect(() =>
	{
		getPollData();
	}, []);

	return (
		<>
			<Divider sx={{ border: '1px solid #A3A3A3' }}/>
			<Grid container>
				<Grid item xs={12} mt={3}>
					<Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
						<Typography sx={{ fontWeight: '600', fontSize: 'var(--pixel18)' }}>Polling</Typography>
						<IconButton>
							<MdOutlineModeEdit color='var(--txtColorBlackL)' cursor={'pointer'} onClick={() => handleNavi(5)}/>
						</IconButton>
					</Stack>
				</Grid>
				<Grid item xs={12} mt={1.5}>
					<TableContainer style={{ width: 'var(--percent100)' }}>
						<Table style={{ width: 'var(--percent100)' }}>
							<TableBody>
								{pollsList?.map((item, index) => (
									<PollsTableBody
										key={`${item?.question} -${index}`}
										eachItem={item}
										viewOnly
										handleUpdate={() => {}}
										handleDelete={() => {}}
									/>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
		</>
	);
};

export default PollSection;